import React from "react";
import { useTranslation } from 'react-i18next';

import { getAssetClassType, sortByAssetClassType } from "./PortfolioStructureTransformer";

const PortfolioContent = ({
  FundTypeDropdownValues = [],
  DepotBreakdowns = [],
}) => {
	const { t, i18n } = useTranslation();
	let funds = DepotBreakdowns?.values;
	if (funds) {
		funds = sortByAssetClassType(funds);
	}
  return (
	<>
		<div className="portfolio-content u-margin-left-30-small-up u-margin-right-30-small-up u-margin-left-20-small-down u-margin-right-20-small-down">
			<div className="l-grid__row justify-content-center">
				<div className="l-grid__column-5 l-grid__column-medium-5 l-grid__column-small-12 u-padding-top-lg">
					<h6 className="c-heading u-padding-top-md" tabIndex="0">
						{t('individualFundsLabel')}
					</h6>
				</div>
				<div className="l-grid__column-5 l-grid__column-medium-5 l-grid__column-small-12 u-padding-top-lg">
					<div className="l-grid__row">
						<div className="l-grid__column-6 l-grid__column-large-6 u-hidden-medium-down u-text-align-right">
							<p className="c-copy u-margin-top-m" tabIndex="0">
								{t('fundTypeSelectorLabel')}
							</p>
						</div>
						<div className="l-grid__column-6 l-grid__column-large-6 l-grid__column-medium-12 l-grid__column-small-12 portfolio-sorting">
							<div className="c-select js-select u-margin-bottom-2m c-natural-language-form__form-body__selector c-natural-language-form__form-body__selector--long js-natural-form-selector-handler">
								<select
									className="c-select__natural"
									name="select-1"
									aria-hidden="false"
									data-label={t('dropdownCaptionLabel')}
									id="FundsortSelect"
								>
								{FundTypeDropdownValues.map((fundtype, index) => (
									<option
										value={i18n.exists(fundtype.label) ? t(fundtype.label) : fundtype.label}
										data-filter={fundtype.value}
										key={index}
										id={`fundSelect-${index}`}>
										{i18n.exists(fundtype.label) ? t(fundtype.label) : fundtype.label}
									</option>
								))}
									<option
										value={t('allLabel')}
										data-filter="all"
										id={`fundSelect-${FundTypeDropdownValues.length}`}>
										{t('allLabel')}
									</option>
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="l-grid__row justify-content-center">
				<div className="l-grid__column-10 l-grid__column-medium-10 l-grid__column-small-12">
					<table className="c-table c-table--agi has-border c-table--sortable c-table--compact-header js-portfolio-sort">
					<thead>
						<tr className="c-table__header__row" tabIndex="0">
						<th className="c-table__header__cell c-table__header__cell--sortable c-table--sortable c-table--compact-header" data-sort="type" tabIndex="0">
							<div className="c-table__header-wrapper">
							<span className="c-table__sort-indicator">
								<i className="c-icon c-icon--chevron-up" aria-hidden="true"></i>
								<i className="c-icon c-icon--chevron-down u-line-height-0 " aria-hidden="true"></i>
							</span>
							<span className="c-table__header__title" tabIndex="0">{t('tableColumnShareLabel')}</span>
							</div>
						</th>
						<th className="c-table__header__cell c-table__header__cell--sortable c-table--sortable c-table--compact-header" data-sort="name" tabIndex="0">
							<div className="c-table__header-wrapper">
							<span className="c-table__sort-indicator">
								<i className="c-icon c-icon--chevron-up" aria-hidden="true"></i>
								<i className="c-icon c-icon--chevron-down u-line-height-0 " aria-hidden="true"></i>
							</span>
							<span className="c-table__header__title" tabIndex="0">{t('tableColumnFundNameLabel')}</span>
							</div>
						</th>
						<th className="c-table__header__cell c-table__header__cell--sortable c-table--sortable c-table--compact-header" data-sort="allotment" tabIndex="0">
							<div className="c-table__header-wrapper">
							<span className="c-table__sort-indicator">
								<i className="c-icon c-icon--chevron-up" aria-hidden="true"></i>
								<i className="c-icon c-icon--chevron-down u-line-height-0 " aria-hidden="true"></i>
							</span>
							<span className="c-table__header__title" tabIndex="0">{t('tableColumnShareLabel')}</span>
							</div>
						</th>
						</tr>
					</thead>
					</table>
					<ul id="portfolio-accordion" className="c-agi-accordion c-portfolio-accordian js-agi-accordion" data-autocollapse="false">
					{funds.map((breakdownValue, index) => {
    					const assetClassType = getAssetClassType(breakdownValue.AssetClass);
    					return (
						<li className={`c-agi-accordion__item ${assetClassType}`} data-type={assetClassType} data-allotment={breakdownValue.value} data-name={breakdownValue.FundName} key={index}>
						<button aria-controls={`tab-content-${index}`} className="c-agi-accordion__button">
							<span className="accordian-label">
							<span className="justify-content-start u-margin-none">{breakdownValue.FundName}</span>
							<span className="justify-content-end u-margin-none c-percent">{breakdownValue.value}</span>
							</span>
						</button>
						<div className="c-agi-accordion__content" aria-labelledby={`tab-content-${index}`}>
							<h3 className="u-heading u-margin-bottom-2m">{breakdownValue.label}</h3>
							<p className="c-copy u-margin-bottom-2m">{breakdownValue.FundCharacteristics}</p>
							<div className="l-grid__row">
							<div className="l-grid__column-1 l-grid__column-medium-1 u-text-align-center u-padding-right-none u-hidden-medium-down">
								<div className="pie-wrapper accordian-circle" data-type={assetClassType} data-allotment={breakdownValue.value}>
								</div>
							</div>
							{breakdownValue.FundManagers && breakdownValue.FundManagers.length > 0 && (
								<div className="c-image-accordian l-grid__column-1 l-grid__column-medium-1 u-text-align-center u-hidden-medium-down">
								{/* Image rendering logic here */}
								</div>
							)}
							<div className="l-grid__column-10 l-grid__column-medium-10 l-grid__column-small-12">
								{breakdownValue.FundManagers && breakdownValue.FundManagers.length > 0 && (
								<>
									<h3 className="u-heading u-margin-bottom-none">{breakdownValue.FundManagers[0].Name}</h3>
									<p className="c-copy u-margin-top-none u-margin-bottom-m">{t('fundManagerLabel')}</p>
								</>
								)}
								<p className="c-copy u-margin-top-m 0-margin-bottom-none" tabIndex="0">{breakdownValue.InvestmentObjective}</p>
							</div>
							</div>
						</div>
						</li>
						);
					})}
					</ul>
				</div>
			</div>

		</div>


		<div className="l-grid__row justify-content-center">
            <div className="l-grid__column-12 u-text-align-center u-margin-top-m">
				{/* eslint-disable-next-line */}
                <a className="c-link c-link--block u-margin-top-m c-link--icon open-detailed-view" tabIndex="0" href="#" aria-label="">
                    <span aria-hidden="true" className="c-link__icon c-icon c-icon--arrow-down"></span>
                    <span className="c-link__text">{t('openLabel')}</span>
                </a>
				{/* eslint-disable-next-line */}
                <a className="c-link c-link--block u-margin-top-m c-link--icon u-hidden close-detailed-view" tabIndex="0" href="#" aria-label="">
                    <span aria-hidden="true" className="c-link__icon c-icon c-icon--arrow-up"></span>
                    <span className="c-link__text">{t('closeLabel')}</span>
                </a>
            </div>
        </div>		
	</>	
  );
};

export default PortfolioContent;
